import { useCallback, useEffect, useState } from 'react'
import cn from 'clsx'
import './SingleComment.css'
import * as actions from '@actions'
import { toast } from 'react-toastify'

const SingleComment = ({ documentId, noRadius }) => {
    
    const [isActive, setIsActive] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [showOutdatedComment, setShowOutdatedComment] = useState(false)
    const [comment, setComment] = useState('')
    const [savedComment, setSavedComment] = useState('')
    
    const isOutdated = useCallback(() => comment !== savedComment, [comment, savedComment])
    
    useEffect(() => {
        actions.getDocumentComment(documentId)
            .then(res => {
                setComment(res.comment)
                setSavedComment(res.comment)
                setShowOutdatedComment(false)
            })
    }, [])
    
    useEffect(() => {
        if (isActive)
            setShowOutdatedComment(isOutdated())
    }, [isActive])
    
    const saveComment = async () => {
        
        if (isSaving) return
        setIsSaving(true)
        
        try {
            
            const res = await actions.saveDocumentComment(documentId, comment)
            
            setSavedComment(res.comment)
            setShowOutdatedComment(false)
            setIsActive(false)
            toast.success('Comment saved successfully')
        } catch (e) {
            console.log(e)
            toast.error('Failed to save comment, please try again')
        }
        
        setIsSaving(false)
    }
    
    return (
        
        <div className={cn('single-comment', { 'single-comment--active': isActive })}>
            
            <button className={cn('btn btn-neutral', { 'rounded-s-none': noRadius })}
                onClick={() => setIsActive(!isActive)}>
                Comments
            </button>
            
            {isActive && (
                <div className="single-comment__data">
                    
                    <textarea
                        placeholder="Add your comments on the document..."
                        onChange={ev => setComment(ev.target.value)}
                        value={comment} />
                    
                    {showOutdatedComment && (
                        <span className="error-message">
                            Save comment to not lose updates you have done
                        </span>
                    )}
                    
                    <button
                        className="btn btn-block btn-primary"
                        disabled={isSaving}
                        onClick={() => saveComment()}>
                        Save Comment
                    </button>
                
                </div>
            )}
        
        </div>
    )
}

export default SingleComment
